import { SET_CURRENT_MODULE } from '../actions/module';
const filters = (state = {}, action) => {
  switch (action.type) {
    case SET_CURRENT_MODULE:
      return {
        ...state,
        currentModule: action.payload,
      };
    default:
      return state;
  }
};

export default filters;
